// src/components/PolarChart.js
import React from "react";
import { PolarArea } from "react-chartjs-2";
import {
  Chart as ChartJS,
  RadialLinearScale,
  ArcElement,
  Tooltip,
  Legend,
  Title,
} from "chart.js";

// Registrar componentes necesarios
ChartJS.register(RadialLinearScale, ArcElement, Tooltip, Legend, Title);

// Colores base
const CHART_COLORS = {
  red: "rgb(255, 99, 132)",
  orange: "rgb(255, 159, 64)",
  yellow: "rgb(255, 205, 86)",
  green: "rgb(75, 192, 192)",
  blue: "rgb(54, 162, 235)",
};

// Función para hacer colores transparentes
const transparentize = (color, opacity) => {
  const alpha = opacity ?? 0.5;
  return color.replace("rgb", "rgba").replace(")", `, ${alpha})`);
};

// Etiquetas y datos simulados
const labels = ["Red", "Orange", "Yellow", "Green", "Blue"];

const data = {
  labels,
  datasets: [
    {
      label: "Dataset 1",
      data: [15, 25, 35, 20, 40],
      backgroundColor: [
        transparentize(CHART_COLORS.red, 0.5),
        transparentize(CHART_COLORS.orange, 0.5),
        transparentize(CHART_COLORS.yellow, 0.5),
        transparentize(CHART_COLORS.green, 0.5),
        transparentize(CHART_COLORS.blue, 0.5),
      ],
    },
  ],
};

// Opciones del gráfico
const options = {
  responsive: true,
  scales: {
    r: {
      pointLabels: {
        display: true,
        centerPointLabels: true,
        font: {
          size: 18,
        },
      },
    },
  },
  plugins: {
    legend: {
      position: "top",
    },
    title: {
      display: true,
      text: "Chart.js Polar Area Chart With Centered Point Labels",
    },
  },
};

const Chart3 = () => {
  return <PolarArea data={data} options={options} />;
};

export default Chart3;
